import { useState } from "react";

import { useQuery } from "@apollo/client";
import capitalize from "lodash/capitalize";
import { useHotkeys } from "react-hotkeys-hook";
import { useMediaQuery } from "react-responsive";

import sanitizeGraphqlObject from "@/components/helpers/graphql/sanitize-graphql-object";
import { Box, Flex } from "@/components/layout/flexbox";
import { isXsQuery } from "@/components/layout/Media";
import FadeInBox from "@/components/pieces/FadeInBox";
import Clickable from "@/components/pieces/interaction/Clickable";
import JobFunctionMultiselect from "@/components/pieces/jobs/JobFunctionMultiselect";
import CtaButton from "@/components/pieces/onboarding/CtaButton";
import Form from "@/components/pieces/onboarding/Form";
import PageTitle from "@/components/pieces/onboarding/PageTitle";
import StyledTag from "@/components/pieces/StyledTag";
import { PopularJobFunctionsDocument } from "@/graphql";

export default function JobFunctions({ intakeForm, loading, saveIntakeForm }) {
  const [jobFunctions, setJobFunctions] = useState(
    intakeForm.jobFunctions.map(sanitizeGraphqlObject),
  );
  const { data } = useQuery(PopularJobFunctionsDocument);

  function submit() {
    if (loading) {
      return;
    }
    saveIntakeForm({
      jobFunctionIds: jobFunctions.map((s) => `${s.id}`),
      jobFunctionsSkipped: Object.keys(jobFunctions).length === 0,
    });
  }
  useHotkeys("enter", submit);

  const popularJobFunctions = (data ? data.popularJobFunctions : []).filter(
    (ps) => !jobFunctions.find((s) => s.id === ps.id),
  );

  const isXs = useMediaQuery(isXsQuery);

  return (
    <Flex justifyContent="center">
      <Box width={[1, 1, 670]}>
        <FadeInBox>
          <PageTitle
            title="Which job functions are relevant?"
            subtitle="Leave blank if you're not sure"
          />
          <Form onSubmit={submit}>
            <JobFunctionMultiselect
              onChange={setJobFunctions}
              autoFocus={true}
              large={!isXs}
              disabled={loading}
              selections={jobFunctions}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  submit();
                }
              }}
            />
          </Form>

          {popularJobFunctions.length ? (
            <Box mt={4}>
              <Box mb={2}>Most Common</Box>
              {popularJobFunctions.map((ps) => {
                return (
                  <Clickable
                    key={ps.id}
                    onClick={() => {
                      setJobFunctions(
                        jobFunctions.concat([sanitizeGraphqlObject(ps)]),
                      );
                    }}
                  >
                    <StyledTag large={!isXs}>
                      {ps.name.replace(/\w+/g, capitalize)}
                    </StyledTag>
                  </Clickable>
                );
              })}
            </Box>
          ) : null}

          <CtaButton loading={loading} onClick={submit} visible={true}>
            Continue
          </CtaButton>
        </FadeInBox>
      </Box>
    </Flex>
  );
}
